export default __webpack_public_path__ + "images/d2215ad26f367b4e279d976ea014de6e.png";